import {SBack, SEditor, SFormUploadImage, SFuncModal, SGeneralForms} from 'shj-components'
import {Button, Divider, Flex, Form, message, Modal, QRCode, Radio, Row, Select, Space, Spin, TreeSelect,} from 'antd'

import styles from './index.module.less'
import {useSearchParams} from 'react-router-dom'
import {IConfig} from 'shj-components/dist/es/SGeneralForms/type'
import {useRequest, useSetState} from 'ahooks'
import {getChildrenDicts} from '@/services/homeService.ts'
import lodash from 'lodash'
import {
  departmentTree,
  queryBuildingInfoByEmployeeId,
  queryContentCategoryList,
  queryContentInfo,
  saveOrUpdateContentInfo,
} from '@/services/content.ts'
import config from '@/config'
import {getDictionaryData} from '@/utils/data.ts'
import {useEffect} from 'react'
import {date2Dayjs, dateFormat} from '@/utils/date.ts'
import dayjs from 'dayjs'
import {VisibilityList} from '@/pages/config/content/articleManage/config.tsx'
import {getUser} from 'shj-utils'

const uploadURL = config.api + 'file-web/file/upload'
const listFactory = (name: string) =>
  Array(10)
    .fill(1)
    .map((_, i) => ({
      label: `${i + 1}${name}`,
      value: `${i + 1}${name}`,
    }))

const shiList = listFactory('室')
const tingList = listFactory('厅')
const weiList = listFactory('卫')

const formatTagIdList = (list: any): Array<any> => {
  return list.map(item => ({
    ...item,
    categoryName: item.categoryName ?? item.tagName,
    disabled: item.categoryName != null,
    childList: item.childList
      ? formatTagIdList(item.childList)
      : item.tagList
        ? formatTagIdList(item.tagList)
        : null,
  }))
}

/**
 * 文章/视频/vr编辑页面
 * @constructor
 */
const AddOrEditSubItem = () => {
  const [form] = Form.useForm()

  const user = getUser()
  const [searchParams] = useSearchParams({})
  const type = searchParams.get('type')
  const detailId = searchParams.get('id')
  const [state, setState]: any = useSetState({ edit: false, data: null })

  const {
    loading: loadingEstateList,
    data: estateList,
    runAsync: runEstateList,
  }: any = useRequest(queryBuildingInfoByEmployeeId)

  const {
    loading: loadingDetail,
    data: detail = {},
    runAsync: runDetail,
  } = useRequest(queryContentInfo, { manual: true })

  const { loading: loadingEdit, runAsync: runEdit } = useRequest(saveOrUpdateContentInfo, {
    manual: true,
  })
  const { data: employeeList }: any = useRequest(departmentTree, {
    defaultParams: [user?.companyId, {}],
  })

  useEffect(() => {
    if (detailId) {
      runDetail(detailId).then((data: any) => {
        form.setFieldsValue({
          ...data?.contentPermissionsRes,
          ...data,
          deptIds: (data?.contentPermissionsRes?.contentPermissionsDeptRelRes || []).map(
            item => item?.deptId
          ),
          urlList: (data?.contentUrls || []).map((item: any) => ({ url: item?.url })),
          imageUrl: [{ url: data?.imageUrl }],
          effectiveEndTime: date2Dayjs(data?.effectiveEndTime),
          tagIdList: (data?.contentTags || [])?.map(item => item?.id),
        })
      })
    } else {
      form.setFieldsValue({
        type: VisibilityList[0].value,
      })
    }
  }, [detailId])

  const debounceEstateList = () => {
    const loadOptions = (value: string) => {
      runEstateList({ buildingName: value })
    }
    return lodash.debounce(loadOptions, 200)
  }

  const goBack = () => {
    history.back()
  }

  const onSave = async (params: any) => {
    const values = await form.validateFields()

    const getImage = list => {
      return (list || []).map(item => item.url ?? item?.response?.data?.fileUrl)
    }

    runEdit({
      categoryType: type,
      ...(detail || {}),
      ...values,
      effectiveEndTime: dateFormat(values.effectiveEndTime),
      imageUrl: getImage(values.imageUrl)?.[0],
      urlList: getImage(values.urlList),
      name: VisibilityList.find(item => item.value === values.type)?.label,
      buildingName: (estateList || []).find(item => (item.houseNumber = values.buildingId))?.name,
      ...params,
    }).then(() => {
      message.success('保存成功')
      history.back()
    })
  }

  const httpOptionsFn = async (): Promise<any> => {
    const dictData: any = await getChildrenDicts(['houseDecorateStyle', 'housePropertyType'])
    return Promise.resolve({
      houseDecorateStyle: getDictionaryData(dictData, 'houseDecorateStyle'),
      housePropertyType: getDictionaryData(dictData, 'housePropertyType'),
    })
  }
  const httpOptionsFn3 = async (): Promise<any> => {
    const contentCategoryList = await queryContentCategoryList({
      categoryType: type,
      parentId: 0,
    })
    const tagIdList = await queryContentCategoryList({
      categoryType: 'tag',
      parentId: 0,
    })

    // const tagIdList: any = await queryContentTagList({data: {current: 1, pageSize: 1000}})
    console.log(' formatTagIdList(tagIdList || [])', formatTagIdList(tagIdList || []))
    return Promise.resolve({
      contentCategoryList,
      tagIdList: formatTagIdList(tagIdList || []),
    })
  }

  const formatUploadData = (urls: Array<any>) => {
    return urls.map(item => ({
      url: item.response ? item.response?.data?.fileUrl : item.url,
      name: item.response ? item.response?.data?.originalFilename : item.name,
    }))
  }
  const beforeUpload = (file: any) => {
    if ((file.type || '').startsWith('image')) {
      if (
        !file.name.endsWith('.jpg') &&
        !file.name.endsWith('.bmp') &&
        !file.name.endsWith('.png') &&
        !file.name.endsWith('.jpeg')
      ) {
        message.error('图片必须是jpg/jpeg/png/bmp格式')
        return false
      }
      return true
    }
    message.error('只能上传图片')
    return false
  }
  const beforeUploadVideo = (file: any) => {
    if ((file.type || '').startsWith('video')) {
      if (
        !file.name.endsWith('.mp4') &&
        !file.name.endsWith('.avi') &&
        !file.name.endsWith('.flv') &&
        !file.name.endsWith('.mov') &&
        !file.name.endsWith('.wmv')
      ) {
        message.error('视频必须是mp4/avi/flv/mov/wmv格式')
        return false
      }

      if (file.size > 1024 * 1024 * 200) {
        message.error('视频大小不能超过200M')
        return false
      }
      return true
    }

    message.error('只能上传视频')
    return false
  }

  const preview = () => {
    if (!detailId) {
      message.warning('请显保存再预览')
      return
    }
    SFuncModal({
      content: (
        <Row justify="center">
          <QRCode
            value={`https://cdchzj.cn/links/app?scanscene=2&redirect=${encodeURIComponent(`/custom/share_details?id=${detailId}`)}`}
          />
        </Row>
      ),
      title: '请使用筑筑侠扫码预览',
      okText: '确定',
    })
  }

  const configVR: Array<IConfig> = [
    {
      title: '基本信息',
      formItem: [
        {
          label: '标题',
          name: 'title',
          required: true,
          maxLength: 20,
          spanCol: 24,
        },
        {
          label: '简介',
          name: 'description',
          maxLength: 50,
          spanCol: 24,
        },
        {
          label: '链接',
          name: 'link',
          required: true,
          maxLength: 100,
          spanCol: 24,
        },
        {
          label: '楼盘',
          name: 'buildingId',
          type: 'select',
          required: true,
          spanCol: 24,
          comConfig: {
            filterOption: false,
            showSearch: true,
            loading: loadingEstateList,
            options: estateList || [],
            fieldNames: { label: 'name', value: 'id' },
            onSearch: debounceEstateList(),
          },
        },
        {
          label: '装修风格',
          name: 'designStyleCode',
          data: 'houseDecorateStyle',
          type: 'select',
          comConfig: {
            fieldNames: { label: 'name', value: 'priKey' },
          },
          required: true,
          spanCol: 24,
        },
        {
          label: '房屋类型',
          name: 'houseType',
          data: 'housePropertyType',
          type: 'select',
          comConfig: {
            fieldNames: { label: 'name', value: 'priKey' },
          },
          required: true,
          spanCol: 24,
        },
        {
          label: '建筑面积(平米)',
          name: 'buildArea',
          type: 'inputNumber',
          required: true,
          spanCol: 24,
        },
        {
          label: '装修参考价(万元)',
          name: 'buildingPrice',
          type: 'inputNumber',
          required: true,
          spanCol: 24,
        },
        {
          name: 'title',
          customRender: () => {
            return (
              <Form.Item label="户型" required>
                <Space.Compact>
                  <Form.Item
                    name={'houseRoom'}
                    noStyle
                    rules={[{ required: true, message: '请选择几室' }]}
                  >
                    <Select placeholder="请选择几室" options={shiList} style={{ width: '120px' }} />
                  </Form.Item>
                  <Form.Item
                    name={'houseHall'}
                    noStyle
                    rules={[{ required: true, message: '请选择几厅' }]}
                  >
                    <Select
                      placeholder="请选择几厅"
                      options={tingList}
                      style={{ width: '120px' }}
                    />
                  </Form.Item>
                  <Form.Item
                    name={'houseToilet'}
                    noStyle
                    rules={[{ required: true, message: '请选择几卫' }]}
                  >
                    <Select placeholder="请选择几卫" options={weiList} style={{ width: '120px' }} />
                  </Form.Item>
                </Space.Compact>
              </Form.Item>
            )
          },
          spanCol: 24,
        },
        {
          label: '户型图',
          name: 'urlList',
          required: true,
          children: (
            <SFormUploadImage
              maxCount={1}
              beforeUpload={beforeUpload}
              url={uploadURL}
              setFileUrl={formatUploadData}
            />
          ),
          spanCol: 24,
        },
        {
          label: '正文',
          name: 'content',
          children: (
            <Button
              style={{ width: '200px' }}
              type="primary"
              onClick={() => setState({ edit: true, data: form.getFieldValue('content') })}
            >
              编辑
            </Button>
          ),
          spanCol: 24,
        },
      ],
    },
  ]
  const configOther: Array<IConfig> = [
    {
      title: '基本信息',
      formItem: [
        {
          label: '标题',
          name: 'title',
          required: true,
          maxLength: 20,
          spanCol: 24,
        },
        {
          label: '简介',
          name: 'description',
          maxLength: 50,
          spanCol: 24,
        },
        {
          label: '楼盘',
          name: 'buildingId',
          type: 'select',
          spanCol: 24,
          comConfig: {
            filterOption: false,
            showSearch: true,
            loading: loadingEstateList,
            options: estateList || [],
            fieldNames: { label: 'name', value: 'id' },
            onSearch: debounceEstateList(),
          },
        },
        {
          label: '装修风格',
          name: 'designStyleCode',
          data: 'houseDecorateStyle',
          type: 'select',
          comConfig: {
            fieldNames: { label: 'name', value: 'priKey' },
          },
          spanCol: 24,
        },
        {
          label: '建筑面积(平米)',
          name: 'buildArea',
          type: 'inputNumber',
          comConfig: {
            precision: 2,
            min: 0,
          },
          spanCol: 24,
        },
        type == 'article'
          ? {
              label: '正文',
              name: 'content',
              required: true,
              children: (
                <Button
                  style={{ width: '200px' }}
                  type="primary"
                  onClick={() => setState({ edit: true, data: form.getFieldValue('content') })}
                >
                  编辑
                </Button>
              ),
              spanCol: 24,
            }
          : {
              label: '视频',
              name: 'urlList',
              required: true,
              children: (
                <SFormUploadImage
                  maxCount={1}
                  previewType="video"
                  beforeUpload={beforeUploadVideo}
                  url={uploadURL}
                  setFileUrl={formatUploadData}
                />
              ),
              spanCol: 24,
            },
      ],
    },
  ]
  const configs1: Array<IConfig> = [
    {
      title: '运营信息',
      formItem: [
        {
          name: 'imageUrl',
          customRender: () => (
            <Form.Item
              label="推广图"
              name="imageUrl"
              rules={[{ required: true }]}
              extra="建议尺寸；宽420px，高240px"
            >
              <SFormUploadImage
                maxCount={1}
                beforeUpload={beforeUpload}
                url={uploadURL}
                setFileUrl={formatUploadData}
              />
            </Form.Item>
          ),
        },
        {
          label: '推广文案',
          name: 'copyWriting',
          required: true,
          maxLength: 50,
          spanCol: 24,
        },
        {
          label: '文章分类',
          name: 'categoryId',
          type: 'tree',
          required: true,
          spanCol: 24,
          comConfig: {
            fieldNames: { label: 'categoryName', value: 'id', children: 'childList' },
          },
          data: 'contentCategoryList',
        },
        {
          label: '有效期',
          name: 'effectiveEndTime',
          type: 'date',
          spanCol: 24,
          comConfig: {
            disabledDate: (currentDate: any) => currentDate < dayjs(),
          },
        },
        {
          name: 'type',
          customRender: () => {
            return (
              <Form.Item name="type" label="可见范围">
                <Radio.Group>
                  {VisibilityList.map(item => (
                    <Flex key={item.value} align="center">
                      <Radio style={{ width: '120px' }} value={item.value}>
                        {item.label}
                      </Radio>
                      {item.value == 'dept' && (
                        <Form.Item shouldUpdate noStyle>
                          {instance =>
                            instance.getFieldValue('type') === 'dept' && (
                              <Space.Compact>
                                <Form.Item
                                  name={'deptIds'}
                                  noStyle
                                  rules={[{ required: true, message: '请选择部门' }]}
                                >
                                  <TreeSelect
                                    placeholder="请选择"
                                    style={{ width: '200px' }}
                                    fieldNames={{
                                      label: 'label',
                                      value: 'id',
                                    }}
                                    treeCheckable={true}
                                    treeData={employeeList || []}
                                  />
                                </Form.Item>
                              </Space.Compact>
                            )
                          }
                        </Form.Item>
                      )}
                    </Flex>
                  ))}
                </Radio.Group>
              </Form.Item>
            )
          },
          spanCol: 24,
        },
        {
          label: '内容标签',
          name: 'tagIdList',
          type: 'tree',
          comConfig: {
            treeCheckable: true,
            treeDefaultExpandAll: true,
            multiple: true,
            showCheckedStrategy: TreeSelect.SHOW_PARENT,
            fieldNames: { label: 'categoryName', value: 'id', children: 'childList' },
          },
          data: 'tagIdList',
          spanCol: 24,
        },
        {
          label: '排序',
          name: 'orderSeq',
          type: 'inputNumber',
          comConfig: { min: 0, precision: 0 },
          spanCol: 24,
        },
      ],
    },
  ]

  const configs = type == 'vrCase' ? configVR : configOther

  const getTitle = type => {
    switch (type) {
      case 'article':
        return '文章'
      case 'vrCase':
        return 'VR'
      default:
        return '视频'
    }
  }

  return (
    <SBack
      title={getTitle(type)}
      level={2}
      goPath={goBack}
      extra={[
        <Button key="2" onClick={preview} style={{ marginLeft: 10 }}>
          预览
        </Button>,
        <Button
          type="primary"
          key="3"
          style={{ marginLeft: 10 }}
          disabled={loadingEdit}
          onClick={() => onSave({})}
        >
          保存
        </Button>,
        <Button
          type="primary"
          key="1"
          style={{ marginLeft: 10 }}
          disabled={loadingEdit}
          onClick={() => onSave({ appGrounding: true })}
        >
          保存并上架
        </Button>,
      ]}
    >
      <div className={styles.container}>
        <div className={styles.title_wrap}>
          <div>
            <Modal
              title="内容编辑"
              open={state.edit}
              width="1000px"
              onOk={() => {
                form.setFieldsValue({ content: state.data })
                setState({ edit: false })
              }}
              onCancel={() => setState({ edit: false })}
            >
              <SEditor
                value={state.data}
                key="edit"
                url={uploadURL}
                schema={{'fileUrl':'fileUrl'}}
                onChange={value => {
                  setState({ data: value })
                }}
              />
            </Modal>
            <Spin spinning={loadingDetail || loadingEdit}>
              <Flex>
                <div style={{ width: '50%', padding: '0 40px', flexShrink: '0' }}>
                  <SGeneralForms
                    formConfig={{ form }}
                    httpOptionsFn={httpOptionsFn}
                    layout="vertical"
                    configs={configs}
                  ></SGeneralForms>
                </div>
                <div style={{ width: '60px' }}>
                  <Divider style={{ height: '100%' }} type="vertical" />
                </div>
                <div style={{ width: '50%', padding: '0 40px', flexShrink: '0' }}>
                  <SGeneralForms
                    formConfig={{ form }}
                    httpOptionsFn={httpOptionsFn3}
                    layout="vertical"
                    configs={configs1}
                  ></SGeneralForms>
                </div>
              </Flex>
            </Spin>
          </div>
        </div>
      </div>
    </SBack>
  )
}
export default AddOrEditSubItem
